import userEndpoints from './userEndpoints';
import authEndpoints from './authEndpoints';
import surveyEndpoints from './surveyEndpoints';
import recommendationEndpoints from './recommendationEndpoints';
import tagEndpoints from './tagEndpoints';
import resultEndpoints from './resultEndpoints';

export default {
  ...userEndpoints,
  ...authEndpoints,
  ...surveyEndpoints,
  ...recommendationEndpoints,
  ...tagEndpoints,
  ...resultEndpoints,
};



// WEBPACK FOOTER //
// ./src/endpoints/index.js